import './category-label.scss';
import useTranslation from '@translation-utils/use-translation';

interface ColorProps {
    color: string;
}

export const TotalInvestedLabel = ({ color }: ColorProps) => {
    const { totalsPanel } = useTranslation();

    return <CategoryLabel color={color} label={totalsPanel.totalInvestmentLabel} />;
};

export const FundChartLabel = ({ color }: ColorProps) => {
    const { totalsPanel } = useTranslation();

    return <CategoryLabel color={color} label={totalsPanel.fundLabel} />;
};

export const SavingsAccountChartLabel = ({ color }: ColorProps) => {
    const { totalsPanel } = useTranslation();

    return <CategoryLabel color={color} label={totalsPanel.savingsAccountLabel} />;
};

interface CategoryLabelProps {
    color: string;
    label: string;
}

const CategoryLabel = ({ color, label }: CategoryLabelProps) => (
    <div className="category-label">
        <div className="category-label__color-box" style={{ backgroundColor: color }}></div>
        <span>{label}</span>
    </div>
);
